import React, { Component } from "react";

const veoliaLogo = require('./assets/svg/veolia-logo.svg');
const sepsisLogo = require('./assets/svg/sepsis-logo.svg');

class Footer extends Component {

  render() {
    return (
      <footer>
			<a href="https://sepsistrust.org/" target="_blank" rel="noopener noreferrer"><img className="sepsisLogo" src={sepsisLogo} alt="The Sepsis Trust" width="180" /></a>
      	<a href="https://www.veoliawatertechnologies.co.uk/" target="_blank" rel="noopener noreferrer"><img className="veoliaLogo" src={veoliaLogo} alt="Veolia" width="230" /></a>
      </footer>
    );
  }
}

export default Footer;
